import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { EmailConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeFactory } from '@modules/campaigns/Domain/Factories/NodeFactory';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class EmailNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: EmailConfig) {
    super(id, NodeType.SendEmail, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['copyIds'].length == 0;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  override initNodeConfig() {
    (this.config as EmailConfig).copyIds = [];
    (this.config as EmailConfig).certified = false;
    (this.config as EmailConfig).super = false;
    (this.config as EmailConfig).sendToAllContacts = false;
    (this.config as EmailConfig).expirationDays = 180;
    (this.config as EmailConfig).expirationAt = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.config['copyIds'] == null) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'Email',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }
}
